export default "__VITE_ASSET__1E5n2x_M__"